import React from 'react';
import Page from '../../components/UI/layout/Page';
import PageTitle from '../../components/UI/layout/PageTitle';
import InfoParagraph from '../../components/UI/information-pages/InfoParagraph';
import SectionTitle from '../../components/UI/information-pages/SectionTitle';
import BoxArrowUpLeft, { BoxArrowInUpLeft } from 'react-bootstrap-icons';
import style from './style.module.scss';
import InfoSection from '../../components/UI/information-pages/InfoSection';


const PrivacyPolicyPage = () => {


    const pageTitleTag = "מדיניות פרטיות";
    const lastUpdatedTag = "עודכן לאחרונה בחודש ספטמבר 2026";

    const p1l1Tag = "ברוכים הבאים לאתר האינטרנט של לולהטק (\"האתר\" ו-\"החברה\", בהתאמה).";
    const p1l2Tag = "השימוש באתר, בתכנים הכלולים בו ובשירותים המוצעים דרכו, כפוף למדיניות הפרטיות המפורטת להלן (\"מדיניות הפרטיות\" או \"המדיניות\").";

    const p2l1Tag = "מדיניות זו מפרטת את האופן בו החברה אוספת ומשתמשת במידע אודות גולשים באתר ואודות לקוחות ומשתמשי השירותים של החברה (\"משתמש/ים\", \"אתה\", ו/או \"הנך\") אשר עושים שימוש באתר ו/או בשירותים המוצעים על ידי החברה באתר (\"השירותים\").";

    const p3l1Tag = "איסוף המידע ועיבודו נעשים בהתאם להוראות חוק הגנת הפרטיות, התשמ\"א-1981 (\"חוק הגנת הפרטיות\"), תקנות הגנת הפרטיות (אבטחת מידע), תשע\"ז-2017 ולשאר הדינים החלים על החברה. השימוש בלשון זכר הינו לנוחות בלבד, והאמור להלן חל על כל המינים. האמור במדיניות פרטיות זו בלשון יחיד, אף רבים במשמע. שים לב, כי האתר מכיל קישורים לאתרים ושירותים של צדדים שלישיים, אשר אינם כפופים למדיניות זו. עליך לעיין במדיניות הפרטיות של אותם צדדים שלישיים לפני שתמסור להם מידע אישי כלשהו. פרטיותך חשובה לנו. אנא קרא מדיניות זו בעיון וודא כי האמור בה מקובל עליך. אם אינך מסכים למדיניות הפרטיות, אינך רשאי לעשות שימוש בשירותים לכל מטרה.";

    const p4l1Tag = "לא חלה עליך כל חובה שבדין לספק לנו מידע אישי כלשהו בעת השימוש בשירותים. שיתוף מידע אישי עמנו תלוי ברצונך והסכמתך. עם זאת, מסירת מידע אישי מסוים עשויה להיות הכרחית לצורך קבלת מענה (לדוגמה: פרטי קשר לצורך שליחת מענה חוזר לפנייתך ו/או מילוי פרטים בטופס לקבלת שירות ייעודי) וככל שתבחר שלא לספק מידע זה, לא תוכל החברה להעניק לך את המענה המבוקש.";

    const p5l1Tag = "השימוש באתר החברה מיועד למשתמשים מעל גיל 18. קטינים מתחת לגיל זה אינם מורשים להשתמש באתר. במידה ואינך מעל גיל 18 ו/או אינך בעל כשרות משפטית, הנך נדרש שלא לעשות כל שימוש באתר ושלא לספק לנו כל מידע.";

    // content table tags
    const contentTableTitle = "תוכן העניינים";

    const contentTableTags = [
        { title: "תקציר מדיניות הפרטיות", id: "summary" },
        { title: "המידע שאנו אוספים", id: "information" },
        { title: "כיצד החברה אוספת מידע", id: "collection" },
        { title: "שימוש ב\"עוגיות\" וכלי ניטור", id: "cookies" },
        { title: "מסירת מידע לצדדים שלישיים", id: "third-party" },
        { title: "אבטחת מידע", id: "security" },
        { title: "זכויות המשתמש", id: "user-rights" },
        { title: "שליחת הודעות ומסרים שיווקיים", id: "marketing" },
        { title: "שמירת מידע", id: "data-retention" },
        { title: "העברת מידע אל מחוץ לישראל", id: "data-transfer" },
        { title: "תיקון ועדכון מדיניות הפרטיות", id: "policy-update" },
        { title: "הדין החל", id: "applicable-law" },
        { title: "פנייה אלינו", id: "contact" }
    ];

    const browsers = [
        { name: "Google Chrome", link: "https://support.google.com/chrome/answer/95647" },
        { name: "Mozilla Firefox", link: "https://support.mozilla.org/he/kb/enable-and-disable-cookies-website-preferences" },
        { name: "Microsoft Edge", link: "https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" },
        { name: "Opera", link: "https://help.opera.com/en/latest/web-preferences/#cookies" },
        { name: "Brave", link: "https://support.brave.com/hc/en-us/articles/360018123731-How-do-I-enable-or-disable-cookies-" },
        { name: "Safari", link: "https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" },
        { name: "Internet Explorer", link: "https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies" }
    ]

    return (
        <Page>
            <div className='row mt-4 mb-4'>
                <div className='col-12'>
                    <PageTitle title={pageTitleTag} withReturnBtn />
                </div>
                <div className='col-12'>
                    <h4>{lastUpdatedTag}</h4>
                </div>
            </div>

            <InfoParagraph>
                <p>
                    {p1l1Tag}
                    <br />
                    {p1l2Tag}
                </p>

                <p>
                    {p2l1Tag}
                </p>

                <p>
                    {p3l1Tag}
                </p>
                <p>
                    {p4l1Tag}
                </p>
                <p>
                    {p5l1Tag}
                </p>
            </InfoParagraph>

            <div className={style.contentTableContainer}>
                <h4>{contentTableTitle}</h4>
                <div className={style.contentTableLinksContainer}>
                    {contentTableTags.map((tag, index) => (
                        <div style={{ width: '25%' }}>
                            <a key={tag.id} href={`#${tag.id}`} className={style.contentTableLink}>
                                {index + 1}. {tag.title}
                            </a>
                        </div>
                    ))}

                </div>
            </div>

            <InfoSection id={contentTableTags[0].id}>

                <SectionTitle title={contentTableTags[0].title} />

                <InfoParagraph>
                    תקציר זה של מדיניות הפרטיות מובא לצרכי נוחות בלבד, ואנו ממליצים לקרוא את מדיניות הפרטיות המלאה המביאה בידי המשתמש בצורה ברורה ומפורטת את כלל הפרטים הנוגעים לאיסוף ועיבוד המידע האישי שלו.
                </InfoParagraph>
                <InfoParagraph>
                    <ul>
                        <li>במסגרת מתן השירותים, החברה אוספת בין היתר מידע אישי כגון מזהים מקוונים ופרטי זיהוי וקשר. המידע נמסר על ידי המשתמשים עצמם, נאסף כחלק מהשימוש בשירותי החברה ונאסף באופן אוטומטי.</li>
                        <li>בין היתר נאסף מידע באמצעות קובצי עוגיות (Cookies) וטכנולוגיות דומות, לרבות מידי צדדים שלישיים. השימוש ב-Cookies נעשה בין היתר לצורכי תפעול ואבטחה וכן התאמת התוכן להעדפות המשתמשים, כאשר ניתן לחסום שימוש זה באמצעות הגדרות הדפדפן, בכפוף לכך שחלק מהשירותים עשויים שלא לפעול.</li>
                        <li>חלק מהמידע האישי של המשתמשים עשוי להימסר לצדדים שלישיים לרבות ספקים של שירותי שיווק וספקי שירותי אחסון לצורך תפעול השירותים.</li>
                        <li>אנחנו לא מוכרים מידע אישי אודות המשתמשים שלנו לצדדים שלישיים. אנו מעבירים מידע אישי לצדדים שלישיים רק במסגרת מתן השירותים למשתמשים שלנו, או בנסיבות מוגבלות המפורטות להלן.</li>
                        <li>מידע אודות המשתמשים עשוי להישמר לתקופות הנדרשות למטרות שלשמן נאסף ובכפוף לדין החל.</li>
                        <li>המשתמשים יכולים לבקש בכל עת לממש את הזכויות אשר עומדות לצידם, לרבות זכות העיון וזכות התיקון, והחברה תספק מענה לכל פנייה בהתאם להוראות הדין החל ובכפוף למגבלות הקבועות בדין.</li>
                        <li>ניתן לפנות לחברה בכל בקשה, לרבות עבור הסרה מרשימת הדיוור, באמצעות פרטי הקשר המפורטים, לרבות כתובת הדוא"ל: [support@lola-tech.com].</li>
                    </ul>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[1].id}>
                <SectionTitle title={contentTableTags[1].title} />

                <InfoParagraph>
                    בעת גלישה ושימוש באתר, החברה עשויה לאסוף את סוגי המידע הבאים אודות המשתמש:
                </InfoParagraph>

                <InfoParagraph title='מידע שאינו מזהה אישית את המשתמש ("מידע שאינו אישי"):'>
                    בעת השימוש באתר, החברה אוספת נתונים אנונימיים, אשר אינם מזהים את המשתמש. מידע זה עשוי לכלול מידע אגרגטיבי וסטטיסטי בקשר עם השימוש באתר ובשירותים, לרבות התנהגות משתמשים באתר, עמודים שנצפו, שיתופים לרשתות חברתיות וכו'. החברה עשויה להסתייע בשירותיהם של צדדים שלישיים בהקשר זה, לרבות Google Analytics. מידע מסוג זה לא יזהה אותך באופן אישי. החברה עושה שימוש במידע כאמור על מנת להפעיל ולתפעל את האתר, לנתח מגמות ודפוסי תנועה, לפלח ולשפר את האתר והתוכן וחווית המשתמש, לצורכי סטטיסטיקה ואנליזה פנימית.
                </InfoParagraph>

                <InfoParagraph title='מידע אשר עשוי לזהות את המשתמש ("מידע אישי"):'>
                    כלומר, מידע המאפשר זיהוי של משתמש או עשוי במאמץ סביר לזהות משתמש. מידע אישי זה כולל מזהים מקוונים, כמפורט להלן.
                    <br />
                    להלן פירוט המידע האישי הנאסף על ידי החברה, וכן אופן השימוש בו:
                </InfoParagraph>

                <InfoParagraph title='מזהים מקוונים הנאספים בעת הגלישה באתר'>
                    <p>
                        בעת גלישה באתר, החברה עשויה לאסוף מזהים מקוונים כגון כתובת פרוטוקול אינטרנט ("IP") וכן מזהים טכניים שונים כמפורט לעיל. החברה עשויה לאסוף מידע זה באופן עצמאי או על ידי נותני שירות מטעם החברה.
                    </p>
                    <p>
                        החברה עושה שימוש במזהים מקוונים על מנת להפעיל ולתפעל את האתר, לנתח מגמות ודפוסי תנועה, לפלח ולשפר את האתר, התוכן וחווית המשתמש וכן במסגרת זו להתאים את הפרסום והתוכן באתר להעדפותיו ומאפייניו של המשתמש. כמו כן, החברה עשויה לעשות שימוש במידע זה לצרכי אבטחת האתר, ובכלל זה איתור ומניעה של וירוסים, שימושים אסורים באתר, הונאות או הפרה אחרת של תנאי השימוש או כל דין.
                    </p>
                    <p>
                        למידע נוסף אודות מזהים מקוונים והשימוש בהם, אנא ראה גם מטה תחת החלק העוסק בקובצי עוגיות (Cookies).
                    </p>
                </InfoParagraph>

                <InfoParagraph title='מידע שנאסף בעת יצירת קשר עם החברה'>
                    <p>
                        במידה והמשתמש יבחר לפנות לחברה, בכל אמצעי קשר אשר החברה מעמידה לרשות המשתמשים (לרבות בדוא"ל, או דרך טפסי יצירת קשר מקוונים המוצעים באתר או באמצעות כל טופס מקוון אחר למילוי פרטים וכן באמצעות פנייה טלפונית ו/או אחרת לחברה), המשתמש יתבקש למסור לחברה פרטי יצירת קשר כגון שם מלא, כתובת דוא"ל, מספר טלפון ותוכן ההודעה. בנוסף, המשתמש עשוי לספק לנציגי השירות של החברה מידע נוסף, לשיקול דעתו ומרצונו של המשתמש.
                    </p>
                    <p>
                        החברה תעשה שימוש במידע זה לצורך מתן מענה לפניית המשתמש ולהעניק למשתמש את השירותים והמענה אשר התבקש על ידו.
                    </p>
                    <p>
                        כמו כן, החברה רשאית לשמור תיעוד של פניות אלו ושל המענה שסיפקה כנהוג וכמקובל למטרות שמירת תיעוד של פעילותה.
                    </p>
                </InfoParagraph>

                <InfoParagraph title='מידע שנאסף בעת רישום לדיוור ו/או קבלת מסרים שיווקיים'>
                    <p>במסגרת האתר תוצע למשתמש האפשרות להירשם לקבלת דיוור ו/או ניוזלטר (ידיעון) וחומרים שיווקיים מטעם החברה. לצורך רישום, המשתמש יתבקש להזין כתובת דוא"ל, מס' טלפון ושם מלא.</p>
                    <p>כמו כן, בכפוף להוראות הדין החל, דיוור שיווקי יכול ויישלח למשתמשים קיימים ו/או משתמשים שניהלו משא ומתן עם החברה בקשר לשירותיה.</p>
                    <p>החברה תעשה שימוש במידע זה על מנת לשלוח למשתמש את הדיוור, המידע והחומרים השיווקיים שבהם הביע עניין. נוסף על כך, החברה עשויה לאסוף ולתעד מידע על אופן האינטראקציה שלך עם הדיוור האמור, כגון פתיחת הודעות דוא"ל, לחיצה על קישורים ומידע אחר הנוגע לשימושך בהודעות שנשלחו אליך.</p>
                    <p>משתמש אשר יהיה מעוניין להסיר את עצמו מרשימת הדיוור של החברה יוכל לעשות זאת בפנייה ישירה לחברה בדוא"ל: support@lola-tech.com ו/או באמצעים אשר יוצעו על ידי החברה במסגרת הדיוור עצמו.</p>
                    <p>אנא שים לב כי גם במקרים בהם נסיר אותך לבקשתך מרשימות הדיוור השיווקי שלנו, עדיין ייתכן כי נשלח אליך הודעות תפעוליות ואחרות שאינן בעלות אופי שיווקי.</p>
                </InfoParagraph>

                <InfoParagraph title='מידע שנאסף בעת ביצוע תשלומים ומילוי טפסים מקוונים'>
                    <p>במסגרת האתר תוצע למשתמש האפשרות לביצוע תשלומים מקוונים עבור מוצרים ו/או שירותים הנרכשים מהחברה. כמו כן, תוצע גם האפשרות לבצע פעולות בעזרת מילוי טפסים מקוונים, כגון טפסי הרשמה לשירות, יצירת קשר או פניות תמיכה.</p>
                    <p>החברה תעשה שימוש במידע הנאסף לצורך מתן מענה ואספקת השירותים הנדרשים.</p>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[2].id}>

                <SectionTitle title={contentTableTags[2].title} />

                <InfoParagraph>החברה עשויה לאסוף את המידע לעיל באמצעים הבאים:</InfoParagraph>

                <InfoParagraph>
                    <ul>
                        <li>מידע אשר המשתמש מספק לחברה מרצונו – כגון בעת פנייה לחברה או בעת מילוי טופס מקוון.</li>
                        <li>מידע שנאסף במסגרת השימוש בשירותים וכו'.</li>
                        <li>באופן אוטומטי – באמצעות שימוש בטכנולוגיות כגון קובצי עוגיות (Cookie) ו/או כלי ניטור אחרים.</li>
                        <li>מידע המתקבל מצדדים שלישיים – כדוגמת במסגרת פעילות שיווק דיגיטלית אל מול רשתות חברתיות.</li>
                    </ul>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[3].id}>

                <SectionTitle title={contentTableTags[3].title} />

                <InfoParagraph>
                    אנו משתמשים בקובצי עוגיות (Cookie) (קובצי טקסט קטנים המאוחסנים בדפדפן של המשתמש) וטכנולוגיות דומות אחרות לאיסוף נתונים שונים אודותיך ואודות השימוש שלך בשירותים. טכנולוגיות אלה עוזרות לנו להבין כיצד נעשה שימוש בשירותים שלנו, לנתח דפוסי תנועה, להתאים ולשפר את האתר והתוכן. נוסף לכך, אנו משתמשים בקובצי עוגיות לצורכי אבטחה, כולל זיהוי ומניעה של שימושים אסורים. כמו כן, שימוש בקובצי עוגיות וכלים דומים מאפשר לנו להתאים את האתר להעדפותיך וצרכיך, לנהל פרסום ושיווק דיגיטלי באמצעות צדדים שלישיים בהתאם להעדפות שלך ולמאפייניך ולשמור תיעוד של פעילותך באתר וכיו"ב. במסגרת האתר, החברה עשויה לעשות שימוש בכלי ניטור כאמור מטעם נותני שירותים שהינם צדדים שלישיים.
                </InfoParagraph>
                <InfoParagraph>
                    אנא שים לב כי במסגרת השימוש בשירותים של צדדים שלישיים כשותפי פרסום אליהם מועבר מידע הנאסף באמצעות קובצי עוגיות וטכנולוגיות דומות, אותם צדדים שלישיים יכולים להצליב מידע זה ולצרפו למידע אחר ונוסף שהם מחזיקים אודותיך. לדוגמא, מידע המועבר באמצעות עוגיות לרשת חברתית כזו או אחרת, עשוי להיות מוצלב על ידי הרשת החברתית עם מידע אחר שהיא מחזיקה ביחס אליך, והיא אף עשויה להשתמש בו לצרכים אחרים ו/או נוספים (שאינם קשורים אלינו) בהתאם למדיניות הפרטיות ותנאי השימוש העצמאיים והנפרדים של הרשת החברתית מולך.
                </InfoParagraph>
                <InfoParagraph>
                    המשתמש רשאי להפסיק את איסוף המידע באמצעות עוגיות (למעט מידע אשר הינו הכרחי לתפעול האתר ואבטחתו) באמצעות שינוי הגדרות הדפדפן. יצוין כי במידה ותבחר לחסום או למחוק עוגיות, ייתכן וחלק מהשירותים באתר לא יהיו נגישים ו/או חוויית השימוש שלך באתר עשויה להיות מוגבלת.
                </InfoParagraph>

                <InfoParagraph>
                    <p>
                        ראה מידע אשר עשוי לסייע לך בקישורים הבאים:
                    </p>
                    <table className={style.table}>
                        <thead>
                            <tr>
                                <th className={style.myTd}>סוג דפדפן</th>
                                <th className={style.myTd}>מידע ביחס להפסקת איסוף מידע על ידי עוגיות</th>

                            </tr>
                        </thead>
                        <tbody>
                            {browsers.map((browser) => (
                                <tr key={browser.name} className={style.myTr}>
                                    <td role="rowheader" className={style.myTd}>{browser.name}</td>
                                    <td className={style.myTd}>
                                        <a target='_blank' href={browser.link} className={style.externalBtnLink}>
                                            <BoxArrowInUpLeft />
                                            <span className={style.externalBtnLinkText}>
                                                {browser.link}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[4].id}>

                <SectionTitle title={contentTableTags[4].title} />
                <InfoParagraph>
                    החברה עשויה להעביר מידע אישי אודות המשתמש לצדדים שלישיים, במקרים ובהיקפים המפורטים להלן:
                </InfoParagraph>
                <InfoParagraph title="רשויות וגופים מוסמכים">
                    <p>
                        החברה תהא רשאית למסור מידע ככל שהדבר נדרש או מותר לפי דין, בהתאם לדרישה של רשות מוסמכת, צו שיפוטי או הליך משפטי, וכן לצורך ניהול מחלוקת, טענה, דרישה או תביעה בין המשתמש או מי מטעמו לבין החברה או מי מטעמה. החברה תהא רשאית למסור מידע גם כאשר היא סבורה בתום לב כי הדבר נחוץ לשם מניעת פגיעה חמורה
                    </p>
                    <p>
                        בגופו או ברכושו של אדם, הגנה על זכויותיה או זכויות צדדים שלישיים, או מניעת פעילות בלתי חוקית.
                    </p>
                </InfoParagraph>
                <InfoParagraph title='גורמים המסייעים בהגנה ובאכיפה'>
                    החברה תהא רשאית להעביר מידע לגורמים מקצועיים, טכנולוגיים או משפטיים המסייעים לה באכיפת תנאי השימוש, בהגנה על זכויותיה, באיתור, מניעה, בדיקה או טיפול בהונאה, שימוש לרעה, אירוע אבטחת מידע, תקלה טכנית או פעילות בלתי חוקית, וזאת במידה ובהיקף הנדרשים לצורך האמור.
                </InfoParagraph>
                <InfoParagraph title='ספקים ונותני שירות'>
                    <p>
                        החברה תהא רשאית להעביר מידע לספקים, נותני שירות וקבלני משנה המספקים לה שירותים בקשר להפעלת השירותים ולניהול פעילותה, לרבות:
                    </p>
                    <p>
                        <ul>
                            <li>ספקי תשתיות טכנולוגיות, אחסון, שירותי ענן, שרתים, גיבוי, אבטחת מידע ותחזוקת מערכות;</li>
                            <li>ספקי פיתוח, תפעול, תמיכה טכנית ושירות לקוחות למשתמשים;</li>
                            <li>ספקי סליקה, תשלומים, הנהלת חשבונות ושירותים פיננסיים;</li>
                            <li>ספקי דיוור, פרסום, שיווק, ניהול קמפיינים ומדיה חברתית;</li>
                            <li>פלטפורמות פרסום, אנליטיקה ורשתות חברתיות, שעשויות לעבד את המידע גם בהתאם למדיניות שלהן;</li>
                            <li>יועצים מקצועיים, לרבות עורכי דין ורואי חשבון.</li>
                        </ul>
                    </p>
                    <p>
                        העברת המידע לספקים כאמור תיעשה רק לצורך אספקת השירותים לחברה, בהתאם להוראות הדין החל ולהתחייבויות החלות על אותם ספקים ביחס לשמירת המידע, אבטחתו והשימוש בו.
                    </p>
                </InfoParagraph>
                <InfoParagraph title='צדדים שלישיים לפי בקשת המשתמש או בהסכמתו'>
                    החברה תהא רשאית להעביר מידע לצד שלישי כאשר המשתמש ביקש זאת, הסכים לכך או בחר להשתמש בשירות או בפונקציונליות הכרוכים בהעברת המידע. לאחר מסירת המידע לצד השלישי, עיבוד המידע על ידו יהיה כפוף למדיניות הפרטיות ולתנאים החלים עליו, והחברה לא תהיה אחראית לאופן השימוש במידע על ידי אותו צד שלישי, למעט ככל שנקבע אחרת בדין.
                </InfoParagraph>
                <InfoParagraph title='העברת פעילות במסגרת עסקה עסקית'>
                    בכפוף להוראות הדין, החברה תהא רשאית להעביר מידע אישי לצד שלישי במסגרת מיזוג, רכישה, מכירת נכסים או פעילות, שינוי מבנה ארגוני, גיוס הון או עסקה דומה אחרת, כולה או חלקה, ובכלל זה במסגרת הליכי בדיקת נאותות (Due Diligence) הקשורים לעסקה כאמור. העברת המידע תיעשה בכפוף לכך שמקבל המידע יתחייב להשתמש בו בהתאם לדין ולמגבלות החלות על החברה.
                </InfoParagraph>

            </InfoSection>

            <InfoSection id={contentTableTags[5].id}>

                <SectionTitle title={contentTableTags[5].title} />

                <InfoParagraph>
                    החברה מפעילה מערכות ונהלים מקובלים לאבטחת מידע, אשר נועדו לצמצם את הסיכונים לחדירה בלתי-מורשית ולאפשר הגנה על המידע שהחברה אוספת. יחד עם זאת, מערכות ונהלים אלה לא מעניקים בטחון מוחלט והחברה אינה מתחייבת שמערכותיה, לרבות האתר, יהיו חסינות באופן מוחלט מפני גישה בלתי-מורשית למידע המאוחסן בהם.
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[6].id}>

                <SectionTitle title={contentTableTags[6].title} />
                <InfoParagraph>
                    <p>
                        אתה רשאי לבקש לעיין במידע אודותיך שמצוי אצל החברה באמצעות פנייה בכתב לדוא"ל: support@lola-tech.com. אם מצאת כי המידע שגוי ו/או בלתי מעודכן, תוכל לבקש את תיקונו או מחיקתו. כמו כן, אם המידע השמור אצל החברה משמש לצורך פנייה אישית אל המשתמש, בהתבסס על השתייכות לקבוצת אוכלוסין, שנקבעה על פי אפיון אחד או יותר בהתאם להוראות חוק הגנת הפרטיות (הידועה גם כפניית דיוור ישיר), המשתמש זכאי לדרוש בכתב כי המידע הרלוונטי ביחס למשתמש יימחק ממאגרי החברה.
                    </p>
                    <p>
                        מידע הדרוש לחברה לשם ניהול פעילותה – לרבות תיעוד פעולות ואחרות שביצעת בקשר עם שירותינו – יוסיף להישמר אצלנו על-פי דין, אך לא ישמש עוד לצורך פניות אליך בדיוור ישיר.
                    </p>
                    <p>
                        בעת פנייה לעדכון ו/או עיון ו/או מחיקת מידע כאמור לעיל, החברה רשאית לדרוש מהמשתמש פרטים מסוימים לצורך זיהוי המשתמש בטרם מענה לפנייה האמורה. המענה לפניות יינתן בהתאם להוראות הדין ובכפוף למגבלות הקבועות בהן ולחובות החברה לפי דין.
                    </p>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[7].id}>

                <SectionTitle title={contentTableTags[7].title} />

                <InfoParagraph>
                    <p>
                        כמפורט לעיל, בכפוף להוראות הדין ולקבלת הסכמתך במקרים המתאימים, ייתכן והחברה תשלח אליך הודעות ומסרים שיווקיים מעת לעת. בין היתר, ככל ותבחר להתקשר עימה למטרת קבלת שירותים בכל דרך, ייתכן והחברה תבחר לשלוח אליך מידע ופניות שיווקיות, בהתאם למותר בדין.
                    </p>
                    <p>
                        אם אינך מעוניין לקבל את הדיוור כאמור, אזי תוכל בכל עת לבקש כי נפסיק לשלוח אליך דיוור מעין זה באמצעות הממשקים המשולבים בדיוור עצמו (למשל באמצעות לחיצה על "הסר") או באמצעות שליחת דוא"ל לכתובת: support@lola-tech.com. אנא שים לב כי גם במקרים בהם נסיר אותך לבקשתך מרשימות הדיוור השיווקי שלנו, עדיין ייתכן כי נשלח אליך הודעות תפעוליות ואחרות שאינן בעלות אופי שיווקי.
                    </p>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[8].id}>

                <SectionTitle title={contentTableTags[8].title} />
                <InfoParagraph>
                    אנו שומרים מידע אישי לתקופה הנדרשת על מנת להגשים את מטרות השימוש המתוארות במדיניות זו, להגן או לעמוד על זכויות וטענות משפטיות, לניתוח ושיפור השירותים ובהתאם לדין החל. תיעוד של פעילותה הפנימית של החברה (לרבות שירות ומענה ללקוחות וכו'), יכול ויישמר ללא הגבלה שכן מידע זה מהווה חלק מהתיעוד הפנימי של פעילות החברה. אנו מוחקים מידע (או מעבירים אותו אנונימיזציה) לאחר שהמידע כבר אינו דרוש לנו. נתונים לא אישיים ונתונים אנונימיים סטטיסטיים עשויים להישמר על ידינו ללא הגבלה.
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[9].id}>

                <SectionTitle title={contentTableTags[9].title} />

                <InfoParagraph>

                    <p>
                        במסגרת הפעלת האתר ומתן השירותים, החברה עשויה להעביר מידע אישי אל מחוץ לישראל, לרבות לצורך אחסונו או עיבודו באמצעות ספקי שירות, ספקי שירותי ענן, מערכות מידע וספקים טכנולוגיים אחרים הפועלים במדינות שונות בעולם. ייתכן כי דיני הגנת הפרטיות במדינות שבהן יישמר או יעובד המידע יהיו שונים מהדין החל בישראל.
                    </p>

                    <p>
                        בעצם הגלישה באתר והשימוש בשירותים, ולאחר שניתנה למשתמש אפשרות לעיין במדיניות פרטיות זו, המשתמש מאשר כי הובא לידיעתו שהמידע האישי אודותיו עשוי להיות מועבר, מאוחסן ומעובד מחוץ לישראל, ומסכים לכך, ככל שהסכמה כאמור נדרשת לפי דין.
                    </p>

                    <p>
                        העברת המידע מחוץ לישראל תיעשה בהתאם להוראות הדין החל ובאמצעות מנגנונים, התחייבויות חוזיות ואמצעי הגנה מתאימים, לפי העניין, שנועדו להבטיח כי המידע יישמר באופן מאובטח וכי מקבל המידע יעשה בו שימוש בהתאם למטרות שלשמן הועבר ולהוראות מדיניות זו.
                    </p>
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[10].id}>

                <SectionTitle title={contentTableTags[10].title} />
                <InfoParagraph>
                    החברה שומרת לעצמה את הזכות לתקן או לשנות מעת לעת את תנאי מדיניות הפרטיות, כולם או חלקם, על פי הצורך, בכפוף לשיקול דעתה הבלעדי של החברה. במידה ויבוצעו תיקונים ו/או עדכונים כאמור, אלו ייכנסו לתוקף מיד עם הצגת מדיניות הפרטיות המעודכנת באתר, כאשר תאריך העדכון יבוא לידי ביטוי תחת הכותרת "עודכן לאחרונה" בכותרת מדיניות הפרטיות. ככל ששינוי מהותי מחייב הודעה או הסכמה נוספת לפי דין, החברה תמסור הודעה מתאימה ותבקש את הסכמת המשתמש, לפי העניין, לפני החלת השינוי.
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[11].id}>

                <SectionTitle title={contentTableTags[11].title} />

                <InfoParagraph>
                    על מדיניות פרטיות זו יחולו דיניה של מדינת ישראל וכל מחלוקת תידון בבתי המשפט המוסמכים בתל אביב.
                </InfoParagraph>
            </InfoSection>

            <InfoSection id={contentTableTags[12].id}>

                <SectionTitle title={contentTableTags[12].title} />

                <InfoParagraph>
                    <p>
                        החברה מקפידה על קיום הוראות החוק ומכבדת את זכותם של משתמשי האתר ואחרים. לשאלות בנוגע למדיניות זו, אנא פנה אלינו:
                    </p>
                    <p>
                        לולהטק;
                        <br />
                        יצחק שדה 8, תל אביב
                        <br />
                        בדוא"ל לכתובת הבאה: support@lola-tech.com.
                    </p>
                    <p>
                        ככל שהדבר נדרש בהתאם להוראות הדין, ובכפוף להיקף פעילות החברה, ייתכן ותמונה בחברה ממונה הגנת פרטיות, אליו ניתן יהיה לפנות בכל אחד מאמצעי הקשר האמורים, תוך ציון כי הפנייה מיועדת "לממונה על הגנת הפרטיות".
                    </p>

                </InfoParagraph>
            </InfoSection>

        </Page>
    );
}

export default PrivacyPolicyPage;